import { CONFIG } from 'config/config';

import styled from 'styled-components/macro';

export const InnerWrapper = styled.div`
	align-items: flex-start;
	display: flex;
	flex-direction: column;
	flex-grow: 1;
	width: 90%;

	.title {
		margin-top: 40px;
	}
`;

export const BottomTextWrapper = styled.div`
	display: flex;
	/* align-items: center; */
	width: 100%;
	align-items: flex-end;

	flex-grow: 1;
`;

export const BottomText = styled.p`
	font-size: 12px;
	text-align: center;

	a {
		font-size: 12px;
		color: ${CONFIG.colors.primary};
		font-weight: 700;
		text-decoration: none;
	}
`;
export const BottomTextSpan = styled.span`
	font-size: 12px;
	color: ${CONFIG.colors.primary};
	font-weight: 700;
`;

export const StepWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	margin-top: 20px;
`;
export const StepWrapperItem = styled.div`
	display: flex;
	align-items: flex-start;
	margin-top: 20px;
	justify-content: flex-start;
`;
export const StepCircle = styled.div`
	height: 30px;
	width: 30px;
	background-color: ${CONFIG.colors.primary};
	border-radius: 50%;
	margin-right: 15px;
	font-size: 17px;
	color: ${CONFIG.colors.grey};
	display: flex;
	justify-content: center;
	align-items: center;
	font-weight: 700;
`;

export const IconContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 24px;
	height: 24px;
`;
